import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Plus, Gavel } from 'lucide-react';
import { meetingAPI } from '../../api';
import { toast } from 'sonner';

export const ConsoleElectionTab = ({
  meetingId, meeting, setMeeting, elections, setElections, selectedItem,
  isStockholderMeeting, addElectionDialog, setAddElectionDialog,
  newElection, setNewElection, createElection,
  updateElectionVotes, declareWinners, users,
}) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h3 className="font-medium text-[#1A1D21]">Elections</h3>
      <Button size="sm" onClick={() => setAddElectionDialog(true)} className="bg-[#F58A26] hover:bg-[#E07A1C]" data-testid="add-election-btn"><Plus className="h-4 w-4 mr-1" />New Election</Button>
    </div>
    {elections.length === 0 ? (
      <div className="text-center py-8 text-[#5A6570]"><Gavel className="h-10 w-10 mx-auto mb-3 text-[#A8B1B9]" /><p>No elections for this meeting</p></div>
    ) : (
      elections.map(election => (
        <Card key={election.id} className="border-[#E2E6EA]">
          <CardHeader className="pb-2">
            <div className="flex justify-between items-center">
              <CardTitle className="text-sm flex items-center gap-2"><Gavel className="h-4 w-4 text-[#F58A26]" />Election ({election.voting_method})</CardTitle>
              {!election.winners?.length && <Button size="sm" variant="outline" className="border-[#F58A26] text-[#F58A26]" onClick={() => declareWinners(election.id)}>Declare Winners</Button>}
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {election.candidates?.map((c, idx) => (
                <div key={idx} className="flex items-center gap-3 p-2 rounded border border-[#E2E6EA]">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-[#1A1D21]">{c.name}{election.winners?.includes(c.name) && <Badge className="ml-2 bg-green-100 text-green-800">Elected</Badge>}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Label className="text-xs text-[#5A6570]">Votes:</Label>
                    <Input type="number" min="0" value={c.votes || 0} onChange={e => updateElectionVotes(election.id, idx, 'votes', e.target.value)} className="w-20 h-8 text-center border-[#E2E6EA]" />
                    {isStockholderMeeting && (<><Label className="text-xs text-[#5A6570]">Shares:</Label><Input type="number" min="0" value={c.shares_voted || 0} onChange={e => updateElectionVotes(election.id, idx, 'shares_voted', e.target.value)} className="w-24 h-8 text-center border-[#E2E6EA]" /></>)}
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      ))
    )}

    {/* Secretary Notes */}
    <div>
      <Label className="text-sm font-medium text-[#1A1D21]">Secretary Notes</Label>
      <Textarea value={meeting.election_notes || ''}
        onChange={e => setMeeting({ ...meeting, election_notes: e.target.value })}
        onBlur={() => meetingAPI.update(meetingId, { election_notes: meeting.election_notes }).catch(() => toast.error('Failed to save'))}
        placeholder="Secretary's notes on the election proceedings..." className="mt-1 border-[#E2E6EA] min-h-[60px]" data-testid="election-secretary-notes" />
    </div>

    {/* Election Dialog */}
    <Dialog open={addElectionDialog} onOpenChange={setAddElectionDialog}>
      <DialogContent>
        <DialogHeader><DialogTitle>Create Election</DialogTitle><DialogDescription>Set up an election for directors or officers</DialogDescription></DialogHeader>
        <div className="space-y-4 py-4">
          <div><Label>Candidates (one per line)</Label><Textarea value={newElection.candidates} onChange={e => setNewElection({ ...newElection, candidates: e.target.value })} placeholder={"Juan Dela Cruz\nMaria Santos\nPedro Reyes"} className="min-h-[120px] border-[#E2E6EA]" /></div>
          <div><Label>Voting Method</Label>
            <Select value={newElection.voting_method} onValueChange={v => setNewElection({ ...newElection, voting_method: v })}>
              <SelectTrigger className="border-[#E2E6EA]"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="straight">Straight Voting</SelectItem><SelectItem value="cumulative">Cumulative Voting</SelectItem></SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => setAddElectionDialog(false)}>Cancel</Button><Button onClick={createElection} className="bg-[#F58A26] hover:bg-[#E07A1C]">Create Election</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </div>
);
